<micro-picklist title="Contact Groups"
                [all]="all"
                [listMinSize]="listMinSize"
                [(selectedIds)]="selectedItems"
                (selectedIdsChange)="onNgModelChange($event)">
</micro-picklist>
